import axios from 'axios';
import { DriveItemDTO, DriveLsInputDTO, DriveLsOutDTO } from '@haohan/drive-dto';

export const driveApi = {
	async ls(params: DriveLsInputDTO) {
		const res = await axios.get<DriveLsOutDTO[]>(
			'/api/drive/ls', {params}
		);
		return res.data;
	},
	async getItem(itemID: string) {
		const res = await axios.get<{item: DriveItemDTO}>(
			`/api/drive/get/${itemID}`
		);
		return res.data.item;
	},
};
